module.exports = __webpack_public_path__ + "img/_menu_horiz.c7c0aed4.svg";